import { getEnv } from '@/utils/env';

const BrandliveOldBackdrop = () => {
  const { VITE_ASSET_SERVER } = getEnv();
  return (
    <video
      className="video-garnish"
      preload="auto"
      autoPlay={true}
      muted={true}
      playsInline={true}
      disablePictureInPicture={true}
      loop={true}
    >
      <source src={`${VITE_ASSET_SERVER}/bl-platform/videos/bl_streamslogin_smooth.webm`} type="video/webm" />
    </video>
  );
};

export default BrandliveOldBackdrop;
